module.exports = require("lodash/split");